import React, { ReactChild } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGISH } from '~/Constants/UI.constants';
import { IconTooltip } from '~/Components/IconTooltip';
import { Typography } from '~/UIKit';

export const styles = makeStyles(() => ({
  ItemCreationTooltipContainer: {
    flex: 1,
    textAlign: 'right',
    color: PRIMARY_BLUE,
    fontSize: FONT_SIZE_LARGISH,
    '& > button': {
      ':hover': {
        backgroundColor: 'transparent',
      },
      padding: '0px',
    },
  },
  itemCreationTooltipTitle: {
    lineHeight: '21px',
  },
}));

export const TooltipWrapper = ({
  icon,
  containerRef,
  title,
}: {
  icon: ReactChild;
  containerRef: React.RefObject<HTMLDivElement>;
  title: string;
}) => {
  const { classes } = styles();

  return (
    <div className={classes.ItemCreationTooltipContainer} data-testid="tooltipWrapperTestId">
      <IconTooltip
        tooltipIcon={icon}
        placement={'top-end'}
        container={containerRef?.current}
        popperOptions={{
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'window',
              },
            },
          ],
        }}
      >
        <Typography className={classes.itemCreationTooltipTitle} variant="body2">
          {title}
        </Typography>
      </IconTooltip>
    </div>
  );
};
